export default class Badge {
  constructor (content, color) {
    this.content = content
    this.color = color
  }
}
